import React from "react";
import { Box, Card, Avatar, Rating, Typography } from "@mui/material";

const styles = {
  card: {
    m: 2,
    width: {
      xs: "90%",    
      sm: 280,     
      md: 300,    
      lg: 320,   
    },
    height: {
      xs: "auto",   
      sm: 260,
      md: 280,
      lg: 300,
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    overflow: "hidden",
    borderRadius: 4,
    background: "linear-gradient(145deg, #ffffff 0%, #f9fafb 100%)",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    transition: "all 0.35s ease",
    "&:hover": {
      transform: "translateY(-10px) scale(1.03)",
      boxShadow: "0 25px 50px rgba(0,0,0,0.2)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-50%",
      left: "-50%",
      width: "200%",
      height: "200%",
      background:
        "conic-gradient(from 90deg, #2C3C93, #DA1212, #2C3C93)",  
      animation: "rotate 5s linear infinite",
      zIndex: 0,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      inset: "4px",
      borderRadius: 4,
      background: "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,255,255,0.98))",
      zIndex: 1,
    },
    "@keyframes rotate": {
      to: { transform: "rotate(1turn)" },
    },
  },
  contentWrapper: {
    position: "relative",
    zIndex: 2,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  userInfo: {
    m: 1,
    p: 1,
    display: "flex",
    marginBottom: 0,
    alignItems: "center",
  },
  feedback: {
    marginTop: 2,
    marginLeft: 2,
    marginRight: 2,
    flex: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    fontStyle: "italic",
    opacity: 0.95,
  },
  rating: {
    m: 1,
    p: 1,
    display: "flex",
  },
};

const FeedbackCard = ({ data, primaryColor }) => {
  const { name, feedback, rating } = data;

  return (
    <Card raised sx={styles.card}>
      <Box sx={styles.contentWrapper}>
        {/* user info */}
        <Box sx={styles.userInfo}>
          <Avatar
            sx={{
              background: `linear-gradient(135deg, #DA1212, #DA1212)`,
            }}
          >
            {name[0]}
          </Avatar>
          <Typography
            sx={{
              m: 1,
              fontWeight: 700,
              fontSize: { xs: "1rem", sm: "1.05rem", md: "1.1rem" },
              color: "#2C3C93",
            }}
          >
            {name}
          </Typography>
        </Box>

        {/* feedback */}
        <Box sx={styles.feedback}>
          <Typography sx={{ fontSize: { xs: "0.85rem", sm: "0.9rem", md: "1rem" } }}>
            {feedback?.length > 180
              ? feedback?.substring(0, 180 - 3) + "..."
              : feedback}
          </Typography>
        </Box>

        {/* rating */}
        <Box sx={styles.rating}>
          <Rating
            value={rating}
            readOnly
            sx={{
              "& .MuiRating-iconFilled": {
                color: "#FFDF00", // golden stars
              },
              "& .MuiRating-iconEmpty": {
                color: "#2C3C93",  
              },
            }}
          />
        </Box>
      </Box>
    </Card>
  );
};

export default FeedbackCard;